import { useSyncExternalStore } from 'react';

export type ResolvedTheme = 'light' | 'dark';

const getDocumentTheme = (): ResolvedTheme => {
  if (typeof document === 'undefined') return 'dark';
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
};

const subscribeToDocumentTheme = (onStoreChange: () => void) => {
  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return () => {};

  const observer = new MutationObserver(onStoreChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  return () => observer.disconnect();
};

export function useResolvedTheme(theme?: ResolvedTheme): ResolvedTheme {
  const documentTheme = useSyncExternalStore(
    subscribeToDocumentTheme,
    getDocumentTheme,
    (): ResolvedTheme => 'dark',
  );
  return theme ?? documentTheme;
}
